import useLabels from "hooks/useLabels";

type BookmarkEmptyProps = {
  tab: "papers" | "searches";
};

function BookmarkEmpty({ tab }: BookmarkEmptyProps) {
  const [labels] = useLabels(
    "features.bookmark-lists.bookmark-list-detail.bookmarks-empty"
  );

  return (
    <div className="text-center">
      <i className="text-4xl icon-folder-closed" />
      <h2 data-testid="title" className="mt-4 lg-bold">
        {labels["no-items-saved"].replace("{items}", tab)}
      </h2>
      <p data-testid="try-searching" className="mt-4 text-fg-muted">
        {labels["try-searching"]}
      </p>
      <a
        href={`/results?q=${labels["query-text"]}`}
        className="inline-flex justify-between gap-4 p-3 mt-3 border border-border-base bg-bg-faint rounded-xl"
      >
        <span className="text-fg-base sm-normal">{labels["query-text"]}</span>
        <span>
          <i className="icon-search text-fg-muted" />
        </span>
      </a>
    </div>
  );
}

export default BookmarkEmpty;
